var tip_config, tip_amount, tip_index = 2;

function getTip(t) {
    if ("Your Shopping Cart" === document.querySelector("[property='og:title']").getAttribute("content")) {
        const e = [];
        return void 0 !== t && (tip_amount = t.getAttribute("value")), fetch("/cart.json").then((i => i.json().then((i => (i.items.forEach((function (t) {
            e.push({
                id: t.id,
                product_id: t.product_id,
                quantity: t.quantity,
                price: t.price / 100,
                total_amount: t.final_line_price / 100
            })
        })), fetch("/apps/kumquat/get-tips", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({items: e})
        }).then((i => i.json().then((i => {
            if (tip_config = i.klass, 1 == e.length && e[0].id == tip_config.default_variant) document.getElementById("product-total").setAttribute("value", "0"), document.getElementById("product-total").innerHTML = 0; else {
                let t = document.getElementById("tip-amount"), i = calculetProductTotal(e, tip_config.default_variant);
                document.getElementById("product-total").innerHTML = t.getAttribute("currencysymbol") + i.toFixed(2) + " " + t.getAttribute("iso_code"), document.getElementById("product-total").setAttribute("value", "" + 100 * i)
            }
            void 0 !== t && (tip_index = 0 == tip_amount ? 0 : tip_config.tip_downgrade == tip_amount ? 1 : tip_config.tip_upgrade == tip_amount ? 3 : 2);
            let n = setEdit(!0), o = document.getElementById("tip-downgrade"),
                r = document.getElementById("tip-upgrade"), d = document.getElementById("tip-recommended");
            o.innerHTML = o.getAttribute("currencysymbol") + tip_config.tip_downgrade.toFixed(2), r.innerHTML = r.getAttribute("currencysymbol") + tip_config.tip_upgrade.toFixed(2), d.innerHTML = d.getAttribute("currencysymbol") + tip_config.tip_recommended.toFixed(2);
            var a = document.getElementsByClassName("realy-tip");
            0 != a.length && (a[0].setAttribute("value", n), tip_amount = n);
            let u = "cart/add.js", c = {items: [{id: i.klass.default_variant, quantity: n}]};
            return i.klass.is_tip_product && (c = {updates: {[parseInt(i.klass.default_variant)]: n}}, u = "cart/update.js"), setCart(c, u, e, tip_config)
        })))))))))
    }
}

function setEdit(t) {
    let e, i, n = document.getElementById("tip-amount");
    0 == tip_index ? (e = 0, setActiveClass("zero", "zero"), i = 0) : 1 == tip_index ? (e = tip_config.tip_downgrade, setActiveClass("tip-downgrade", "first"), i = tip_config.tip_downgrade) : 2 == tip_index ? (e = tip_config.tip_recommended, setActiveClass("tip-recommended", "secound"), i = tip_config.tip_recommended) : 3 == tip_index ? (e = tip_config.tip_upgrade, setActiveClass("tip-upgrade", "third"), i = tip_config.tip_upgrade) : 4 == tip_index && (e = n.value, setActiveClass("tip-other", "fourth"), i = n.value), 0 != i && "" != i || (i = 0);
    let o = n.getAttribute("currencysymbol") + parseFloat(i).toFixed(2) + " " + n.getAttribute("iso_code");
    document.getElementById("tip").innerHTML = o;
    let r = document.getElementById("product-total").getAttribute("value"), d = parseFloat(i) + .01 * r;
    return document.getElementById("product-total").innerHTML = n.getAttribute("currencysymbol") + parseFloat(.01 * r).toFixed(2) + " " + n.getAttribute("iso_code"), document.getElementsByClassName("totals__subtotal-value")[0].innerHTML = n.getAttribute("currencysymbol") + d.toFixed(2) + " " + n.getAttribute("iso_code"), e
}

function cartEvents() {
    return getTip()
}

function setCart(t, e, i, n) {
    return fetch(window.Shopify.routes.root + e, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(t)
    }).then((t => {
        let e = 0;
        return 0 == n.tip_downgrade && 0 == n.tip_recommended && 0 == n.tip_upgrade && e++, i.forEach((function (t) {
            t.id == n.default_variant && e++
        })), 0 == e && 0 != i.length && location.reload(), t.text()
    }))
}

function showTipEdit() {
    let t = document.getElementById("tip-downgrade"), e = document.getElementById("tip-upgrade"),
        i = document.getElementById("tip-recommended");
    t.innerHTML = t.getAttribute("currencysymbol") + tip_config.tip_downgrade.toFixed(2), e.innerHTML = e.getAttribute("currencysymbol") + tip_config.tip_upgrade.toFixed(2), i.innerHTML = i.getAttribute("currencysymbol") + tip_config.tip_recommended.toFixed(2), setEdit(!0), "block" == document.getElementById("tip-edit").style.display ? document.getElementById("tip-edit").style.display = "none" : document.getElementById("tip-edit").style.display = "block"
}

function setActiveClass(t, e) {
    var i, n, o;
    for (n = document.getElementsByClassName("tab-content"), i = 0; i < n.length; i++) n[i].style.display = "none";
    for (o = document.getElementsByClassName("tablinks"), i = 0; i < o.length; i++) o[i].className = o[i].className.replace(" active", "");
    document.getElementById(e).style.display = "block", document.getElementById(t).className += " active"
}

function setTip(t, e) {
    setActiveClass(t.currentTarget.id, e);
    let i = t.currentTarget.textContent || t.currentTarget.innerText;
    if ("Other" == i) {
        let t = document.getElementById("tip-amount"), e = 0;
        0 == t.value && "" == t.value || (e = parseFloat(t.value)), i = t.getAttribute("currencysymbol") + parseFloat(e).toFixed(2)
    }
    document.getElementById("tip").innerHTML = i + " " + t.currentTarget.getAttribute("iso_code"), "zero" == t.currentTarget.id ? tip_index = 0 : "tip-downgrade" == t.currentTarget.id ? tip_index = 1 : "tip-recommended" == t.currentTarget.id ? tip_index = 2 : "tip-upgrade" == t.currentTarget.id ? tip_index = 3 : "tip-other" == t.currentTarget.id && (tip_index = 4), setTipTotal(i.replace(t.currentTarget.getAttribute("currencysymbol"), ""), t.currentTarget.getAttribute("currencysymbol"), t.currentTarget.getAttribute("iso_code"))
}

function applyTip() {
    let t, e = document.getElementById("tip-amount"), i = 0;
    0 == e.value && "" == e.value || (i = parseFloat(e.value)), t = e.getAttribute("currencysymbol") + i.toFixed(2) + " " + e.getAttribute("iso_code"), setTipTotal(i.toFixed(2), e.getAttribute("currencysymbol"), e.getAttribute("iso_code")), document.getElementById("tip").innerHTML = t, document.getElementById("tip-edit").style.display = "none"
}

function setTipTotal(t, e, i) {
    getTip();
    let n = document.getElementById("product-total").getAttribute("value"), o = parseFloat(t) + .01 * n;
    document.getElementById("product-total").innerHTML = e + .01 * n + " " + i, document.getElementsByClassName("totals__subtotal-value")[0].innerHTML = e + o.toFixed(2) + " " + i
}

function calculetProductTotal(t, e) {
    let i = 0;
    return t.forEach((function (t) {
        t.id != e && (i += t.total_amount)
    })), i
}

getTip(document.getElementsByClassName("realy-tip")[0]);